<template>
  <b-modal
    ref="termsConditionsModal"
    id="termsConditionsModal"
    modal-class="terms-conditions-modal"
    size="md"
    backdrop="static"
    centered
    hide-header
    hide-footer
  >
    <div class="rounded text-left p-3" style="background: #dee9f5;">
      <p class="notice-list-header">
        直近在籍企業など、あなたの情報を公開したくない企業が含まれていないか十分注意してください。
      </p>
      <br />
      <ul class="notice-list">
        <li>
          <strong>あなたのキャリア登録情報が企業へ公開されます。</strong>
        </li>
        <li>
          <strong>企業側はあなたが他にキャリア登録している企業を知ることはできません。</strong>
        </li>
        <li>
          <strong>許諾無しにあなたがキャリア登録していない企業へ情報が公開されることはありません。</strong>
        </li>
      </ul>
    </div>
    
    <div class="swal-footer d-flex justify-content-center custom-modal-footer full p-4">
      <button
        class="btn text-white btn-sm rounded mx-lg-3 mx-1 font-14 font-bold cancelBtn w-230"
        @click="$emit('cancel')"
      >
        キャンセル
      </button>
      <button
        class="btn text-white btn-sm rounded mx-lg-3 mx-1 font-12 text-center confirmBtn w-230"
        @click="handleAgree"
      >
        注意事項に同意して <br />
        <span class="font-bold font-14">スカウト希望する</span>
      </button>
    </div>
    
    <div class="swal-footer d-flex justify-content-center custom-modal-footer mobile p-4">
      <button
        class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-12 text-center confirmBtn w-230 mb-2"
        @click="handleAgree"
        :disabled="loading"
      >
        <span style="font-size:14px">注意事項に同意して</span> <br />
        <span class="font-bold font-18">スカウト希望する</span>
      </button>
      <button
        class="btn text-white btn-sm rounded py-2 px-5 mx-lg-5 mx-1 font-14 cancelBtn w-230 mt-3"
        @click="$emit('cancel')"
        :disabled="loading"
      >
        キャンセル
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "TermsConditionsModal",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    show() {
      this.$refs.termsConditionsModal.show();
    },
    hide() {
      this.$refs.termsConditionsModal.hide();
    },
    handleAgree() {
      this.$emit('agree');
      this.hide();
    }
  }
};
</script>

<style scoped>
>>> .terms-conditions-modal .modal-body {
  padding: 0 !important;
}

>>> .terms-conditions-modal .modal {
  padding-left: 0px !important;
}

.notice-list-header {
  color: #ff0000;
  margin-top: 12px;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
}

.notice-list {
  padding-left: 20px;
  margin-left: 0;
  line-height: 1.8;
  color: #3c3c3c;
}

.cancelBtn {
  background: #666666;
  border: 1px solid #666666;
}

.cancelBtn:hover {
  background: #494949 !important;
}

.confirmBtn {
  background: #ff0000;
  border: 1px solid #ff0000;
}

.confirmBtn:hover {
  background: #c20101 !important;
}

.w-230 {
  width: 230px;
  height: 60px;
  padding-left: 12px !important;
  padding-right: 12px !important;
  white-space: normal;
  line-height: 1.4;
}

.mobile {
  display: none !important;
}

@media (max-width: 768px) {
  .full {
    display: none !important;
  }
  .mobile {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 12px;
    text-align: center;
  }
  .mobile .confirmBtn,
  .mobile .cancelBtn {
    width: 318px !important;
    height: 53px !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .notice-list-header {
    font-size: 20px;
  }
}
</style> 